import { createFileRoute } from "@tanstack/react-router";
import SportFixtureDetail from "@/pages/SportFixtureDetail";
import { MainLayout } from "@/components/layout/MainLayout";
import { readableFixture, socialMeta } from "@/lib/routeSocial";
import { findUsSport } from "@/lib/oddsSports";

export const Route = createFileRoute("/{$sport}-predictions/match/$slug")({
  head: ({ params }) => {
    const sport = findUsSport(params.sport);
    const { name } = readableFixture(params.slug);
    const label = sport?.label ?? "Match";
    return {
      meta: socialMeta({
        seo: { topics: [params.sport, "fixtures"] },
        title: `${name} Prediction & Odds | Statlign`,
        description: `${name} ${label.toLowerCase()} prediction with model probability, market odds and the value edge Statlign found.`,
        ogType: "article",
        ...(sport ? { image: `https://statlign.com/og-${sport.slug}.jpg` } : {}),
      }),
    };
  },
  component: () => (
    <MainLayout>
      <SportFixtureDetail />
    </MainLayout>
  ),
});
